import { ITransactionByDigitizedCard } from '@/features/cards/store/models/card.model';
import {
  getCardTransactionConfigKey,
  TCardTransactionColumnSetting,
} from '@/features/cards/store/models/card-transactions.model';

interface IPaymentMerchantCategoryCellProps {
  transaction: ITransactionByDigitizedCard;
  config?: TCardTransactionColumnSetting;
}

export function PaymentMerchantCategoryCell({ transaction, config }: IPaymentMerchantCategoryCellProps) {
  const categoryData = [
    getCardTransactionConfigKey(config, 'merchantCategoryGroup') && transaction?.merchantCategoryGroup,
    getCardTransactionConfigKey(config, 'merchantCategoryType') && transaction?.merchantCategoryType,
  ]
    .filter(Boolean)
    .join(' > ');

  return (
    <div className="flex flex-col">
      {getCardTransactionConfigKey(config, 'merchantCategory') && (
        <span className="typo-body-semibold-small text-secondary text-nowrap">
          {transaction?.merchantCategory || '/'}
        </span>
      )}
      {!!categoryData && (
        <div className="flex items-center gap-1 typo-body-regular-small text-tertiary">{categoryData}</div>
      )}
    </div>
  );
}
